module.exports = __webpack_public_path__ + "static/media/ZhiBo5.29d76773.png";